import L1 from '../../assets/Layer-1.png'
import L2 from '../../assets/Layer-2.png'
import L3 from '../../assets/Layer-3.png'
import L4 from '../../assets/Layer-4.png'
import stoneSprite from '../../assets/block.jpg'
import * as game from './Game.js'

const imgLayer1 = new Image();
const imgLayer2 = new Image();
const imgLayer3 = new Image();
const imgLayer4 = new Image();
const platform = new Image();

imgLayer1.src = L1
imgLayer2.src = L2
imgLayer3.src = L3
imgLayer4.src = L4
platform.src = stoneSprite

export function bacgrkoundparallax(ctx) {
    class Layer{
        constructor(img, speedModifier, yPosition){
            this.x = -50
            this.y = yPosition
            this.width = 2350
            this.height = 720
            this.x2 = this.width;
            this.image = img;
            this.speedMod = speedModifier
        }
        update(){
            if (this.x < -this.width) {this.x = this.width}
            else {this.x -= game.gameSpeed * this.speedMod}
            if (this.x2 < -this.width) {this.x2 = this.width}
            else {this.x2 -= game.gameSpeed * this.speedMod}
        }
        draw(){
            ctx.globalCompositeOperation = 'destination-over';
            ctx.drawImage(this.image, this.x, this.y, this.width, this.height)
            ctx.drawImage(this.image, this.x2, this.y, this.width, this.height)
        }
    }
    
    let Layer4 = new Layer(imgLayer4, 0.02, 30)
    let Layer3 = new Layer(imgLayer3, 0.3, window.innerHeight / 5)
    let Layer2 = new Layer(imgLayer2, 0.4, 30)
    let Layer1 = new Layer(imgLayer1, 0.8, window.innerHeight / 5)
    let layers = [Layer1, Layer2, Layer3, Layer4]

    function animate(){
        layers.forEach((layer) => {
            layer.update()
            layer.draw()
        })
        requestAnimationFrame(animate)
    }
    animate()
}